import {HttpHeaders} from '@angular/common/http';

export const constants = {
  httpDefaultOptions: {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Context': 'PORTAL'})
  },
  usuarioLogadoKey: 'usuarioKey',
  authorization: 'Authorization',
  clienteKey: 'clienteKey',
  ativoKey: 'ativoKey',
  enderecoSelecionadoKey: 'enderecoSelecionado',
  tipoosSelecionadoKey: 'tipoOsSelecionado',
  ambientes: 'ambientes',
  anexosKey: 'anexosKey',
  locale: 'locale',
  dateFormat: 'dd/MM/yyyy - HH:mm',
  hourFormat: 'HH:mm',
};
